__turbopack_context__.v({
  "backgroundVideo": "herobackgroundvideo-module-scss-module__8gGuIq__backgroundVideo",
  "overlay": "herobackgroundvideo-module-scss-module__8gGuIq__overlay",
  "poster": "herobackgroundvideo-module-scss-module__8gGuIq__poster",
  "posterHidden": "herobackgroundvideo-module-scss-module__8gGuIq__posterHidden",
  "videoHidden": "herobackgroundvideo-module-scss-module__8gGuIq__videoHidden",
  "videoVisible": "herobackgroundvideo-module-scss-module__8gGuIq__videoVisible",
});
